import { apiClient } from "../../api/apiClient";

const RESOURCE = "communications/tickets";

export const createTicketRequest = (ticketBody, clientConfig = {}) => {
  return apiClient(clientConfig).post(RESOURCE, ticketBody);
};

export const updateTicketAsync = (id, body, clientConfig = {}) => {
  return apiClient(clientConfig).put(`${RESOURCE}/${id}`, body);
};

export async function fetchTicketAsync(id, clientConfig = {}) {
  return await apiClient(clientConfig).get(`${RESOURCE}/${id}`);
}

/*
Tickets
 */
export const fetchTicketsAsync = (
  options = {
    params: {
      sort: `["createdAt","DESC"]`,
    },
  },
) => apiClient().get(RESOURCE, options);

/*
Messages
*/
export const addMessageRequest = (
  id,
  content,
  attachments = [],
  clientConfig = {},
) => {
  return apiClient(clientConfig).post(`${RESOURCE}/${id}/messages`, {
    content,
    attachments,
  });
};
